export interface WaveOption {
  value: string;
  label: string;
}

// After W6, waves are monthly and stored in the `wave` meta as `YYYY-MM` (displayed as `WYYYY-MM`).
const FIRST_MONTHLY_WAVE = { year: 2026, month: 1 };

const LEGACY_WAVE_OPTIONS: WaveOption[] = [
  { value: 'all', label: 'All' },
  { value: 'manual', label: 'Manual' },
  { value: '1', label: 'W1' },
  { value: '2', label: 'W2' },
  { value: '3', label: 'W3' },
  { value: '4', label: 'W4' },
  { value: '5', label: 'W5' },
  { value: '6', label: 'W6' },
];

export const buildMonthlyWaveOptions = (now: Date = new Date()): WaveOption[] => {
  const options: WaveOption[] = [];
  let { year, month } = FIRST_MONTHLY_WAVE;
  const endYear = now.getFullYear();
  const endMonth = now.getMonth() + 1;

  while (year < endYear || (year === endYear && month <= endMonth)) {
    const value = `${year}-${String(month).padStart(2, '0')}`;
    options.push({ value, label: `W${value}` });
    month += 1;
    if (month > 12) {
      month = 1;
      year += 1;
    }
  }

  return options;
};

export const buildWaveOptions = (now: Date = new Date()): WaveOption[] => [
  ...LEGACY_WAVE_OPTIONS,
  ...buildMonthlyWaveOptions(now),
];
